/*
 * ENTID フォーム（来店予約・お問い合わせ）の入力確認
 * form[data-entid-form] を対象に、必須チェック（不足を全部集める）→ 確認表示 → 送信 を行う。
 * 入力欄は [data-entid-field] を付け、必須は data-entid-required、確認表示の項目名は data-entid-label で指定する。
 */
(function () {
  'use strict';

  var PRODUCT_PARAM = 'product';

  function initForm(form) {
    if (form.getAttribute('data-entid-ready')) return;
    form.setAttribute('data-entid-ready', 'true');
    var inputPanel = form.querySelector('[data-entid-panel="input"]');
    var confirmPanel = form.querySelector('[data-entid-panel="confirm"]');
    var errorEl = form.querySelector('[data-entid-error]');
    var listEl = form.querySelector('[data-entid-confirm-list]');
    if (!inputPanel || !confirmPanel || !errorEl || !listEl) return;

    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-entid-field]'));

    // URLの product を、空の「対象の商品」欄へ入れる
    var prefill = form.querySelector('[data-entid-prefill="product"]');
    if (prefill && !prefill.value) {
      try {
        var param = new URLSearchParams(window.location.search).get(PRODUCT_PARAM);
        if (param) prefill.value = param;
      } catch (e) {
        /* URLSearchParams が使えない環境では何もしない */
      }
    }

    function markTarget(el) {
      return el.type === 'checkbox' ? el.closest('.entid-form__agree') || el : el;
    }

    function setInvalid(el, invalid) {
      var target = markTarget(el);
      target.classList.toggle('is-invalid', invalid);
      if (invalid) {
        el.setAttribute('aria-invalid', 'true');
      } else {
        el.removeAttribute('aria-invalid');
      }
    }

    function isEmpty(el) {
      if (el.type === 'checkbox') return !el.checked;
      return !el.value.trim();
    }

    function messageFor(problem) {
      var label = problem.el.getAttribute('data-entid-label') || '';
      if (problem.format) return label + 'の形式を確認してください';
      var kind = problem.el.getAttribute('data-entid-kind');
      if (kind === 'check') return label + 'にチェックしてください';
      if (kind === 'select') return label + 'を選択してください';
      return label + 'を入力してください';
    }

    // 不足項目を全部集め、該当欄すべてに赤枠を付け、案内文を1つにまとめる
    function validate() {
      var problems = [];
      fields.forEach(function (el) {
        var required = el.hasAttribute('data-entid-required');
        var problem = null;
        if (required && isEmpty(el)) {
          problem = { el: el, format: false };
        } else if (el.type === 'email' && el.value.trim() && !el.checkValidity()) {
          problem = { el: el, format: true };
        }
        setInvalid(el, !!problem);
        if (problem) problems.push(problem);
      });

      if (problems.length === 0) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return true;
      }

      errorEl.textContent =
        problems.length === 1
          ? messageFor(problems[0])
          : '確認が必要な項目が' + problems.length + '件あります。赤い欄を確認してください';
      errorEl.hidden = false;
      problems[0].el.focus();
      return false;
    }

    function showConfirm() {
      listEl.textContent = '';
      fields.forEach(function (el) {
        if (el.getAttribute('data-entid-confirm') === 'false') return;
        var row = document.createElement('div');
        row.className = 'entid-form__confirm-row';
        var dt = document.createElement('dt');
        dt.textContent = el.getAttribute('data-entid-label') || '';
        var dd = document.createElement('dd');
        var value = el.value;
        if (el.tagName === 'SELECT') {
          value = el.value && el.selectedIndex >= 0 ? el.options[el.selectedIndex].text : '';
        }
        dd.textContent = value && value.trim() ? value : '―';
        row.appendChild(dt);
        row.appendChild(dd);
        listEl.appendChild(row);
      });
      inputPanel.hidden = true;
      confirmPanel.hidden = false;
      form.scrollIntoView();
      // 押したボタンが隠れるので、フォーカスを確認表示へ移す（キーボード・読み上げで次の操作対象が分かるように）
      confirmPanel.setAttribute('tabindex', '-1');
      confirmPanel.focus({ preventScroll: true });
    }

    function showInput() {
      confirmPanel.hidden = true;
      inputPanel.hidden = false;
      form.scrollIntoView();
      // 「修正する」が隠れるので、フォーカスを入力欄の先頭へ戻す
      if (fields.length) fields[0].focus({ preventScroll: true });
    }

    fields.forEach(function (el) {
      var evt = el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'input';
      el.addEventListener(evt, function () {
        if (el.classList.contains('is-invalid') || markTarget(el).classList.contains('is-invalid')) {
          if (!isEmpty(el)) setInvalid(el, false);
        }
      });
    });

    form.querySelector('[data-entid-confirm-button]').addEventListener('click', function () {
      if (validate()) showConfirm();
    });

    form.querySelector('[data-entid-edit-button]').addEventListener('click', showInput);

    // Enterキーなどによる送信は、確認表示に進むまでは止める
    form.addEventListener('submit', function (event) {
      if (confirmPanel.hidden) {
        event.preventDefault();
        if (validate()) showConfirm();
      }
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('form[data-entid-form]'), initForm);
  }

  // 送信後に読み込まれたページでは、完了の表示へフォーカスを移して結果を伝える（ページを開いたときの1回だけ）
  function focusDone() {
    var done = document.querySelector('.entid-form__done');
    if (!done) return;
    done.scrollIntoView({ block: 'center' });
    done.focus({ preventScroll: true });
  }

  function onReady() {
    initAll();
    focusDone();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // テーマエディタでセクションが描き直されたとき
  document.addEventListener('shopify:section:load', initAll);
})();
